// extracted by mini-css-extract-plugin
module.exports = {"info":"JFxb","name":"JFq9","date":"JFg7","trusted":"JFaib","anonym":"JFaid","authorized":"JFaif","trustedBadge":"JFcp"};